<template>
  <div class="container-fluid pb-5 pt-4 px-4">
    <div class="sucesso-card mx-auto">
      <!-- Ícone de sucesso -->
      <div class="text-center mb-4">
        <div class="icone-sucesso mx-auto mb-3">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h4 class="font-weight-bold text-success mb-1">Venda concluída!</h4>
        <p class="text-muted mb-0">Agora basta enviar o link de pagamento ao seu cliente.</p>
      </div>

      <hr />

      <!-- Resumo -->
      <div class="resumo mb-4">
        <div class="resumo-linha">
          <span class="resumo-label">Plano</span>
          <span class="resumo-valor">Registro {{ planoNome }} — <strong>{{ planoPreco }}</strong></span>
        </div>
        <div class="resumo-linha">
          <span class="resumo-label">Cliente</span>
          <span class="resumo-valor">{{ clienteNome }}</span>
        </div>
      </div>

      <!-- Link de pagamento -->
      <div class="link-area mb-4">
        <label class="label-link mb-1">Link de pagamento</label>
        <div class="link-box">
          <span class="link-texto">{{ linkPagamento }}</span>
          <button class="btn-copiar" @click="copiarLink" :class="{ copiado }">
            <span v-if="!copiado">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
              </svg>
              Copiar
            </span>
            <span v-else>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Copiado!
            </span>
          </button>
        </div>
        <p class="texto-instrucao mt-2">
          Copie esse link e envie ao <strong>{{ clienteNome }}</strong> para finalizar o processo de pagamento.
        </p>
      </div>

      <!-- Ações -->
      <div class="d-flex justify-content-end">
        <!-- <b-button variant="outline-secondary" @click="$router.push('/dashboard/registros')">
          Ver registros
        </b-button> -->
        <b-button variant="success" @click="$router.push('/dashboard/registros')">
          Novo registro
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copiado: false,
      planoNome: this.$route.params.planoNome || "",
      planoPreco: this.$route.params.planoPreco || "",
      clienteNome: this.$route.params.clienteNome || "",
      linkPagamento: this.$route.params.linkPagamento || "",
    };
  },
  methods: {
    async copiarLink() {
      try {
        await navigator.clipboard.writeText(this.linkPagamento);
        this.copiado = true;
        setTimeout(() => { this.copiado = false; }, 3000);
      } catch {
        // fallback para browsers sem clipboard API
        const el = document.createElement("textarea");
        el.value = this.linkPagamento;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.copiado = true;
        setTimeout(() => { this.copiado = false; }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.sucesso-card {
  max-width: 560px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 36px 32px;
  margin-top: 24px;
}

.icone-sucesso {
  width: 72px;
  height: 72px;
  background: #4b9c2e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resumo {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 16px 20px;
}

.resumo-linha {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 0.92rem;
}

.resumo-linha + .resumo-linha {
  border-top: 1px solid #e9ecef;
}

.resumo-label {
  color: #888;
  font-weight: 500;
}

.resumo-valor {
  color: #333;
}

.label-link {
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  display: block;
}

.link-box {
  display: flex;
  align-items: center;
  border: 2px solid #4b9c2e;
  border-radius: 10px;
  padding: 10px 14px;
  gap: 12px;
  background: #f6fbf3;
}

.link-texto {
  flex: 1;
  font-size: 0.92rem;
  color: #1a3c6e;
  font-weight: 600;
  word-break: break-all;
}

.btn-copiar {
  background: #4b9c2e;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: background 0.2s;
}

.btn-copiar:hover {
  background: #3a7d22;
}

.btn-copiar.copiado {
  background: #1a3c6e;
}

.texto-instrucao {
  font-size: 0.82rem;
  color: #666;
  margin-bottom: 0;
}
</style>
